import { render, staticRenderFns } from "./GoBackArrow.vue?vue&type=template&id=6f4b375d&scoped=true&"
import script from "./GoBackArrow.vue?vue&type=script&lang=js&"
export * from "./GoBackArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4b375d",
  null
  
)

export default component.exports